import { render, staticRenderFns } from "./PaymentReportFields.vue?vue&type=template&id=22163efb&scoped=true"
import script from "./PaymentReportFields.vue?vue&type=script&lang=js"
export * from "./PaymentReportFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22163efb",
  null
  
)

export default component.exports